module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/grand_jury__01-b4a458dfc0393b512cfc50b53af20d04.jpg";